import React, { Component } from 'react';
import * as api from '../../api/api';
import { connect } from 'react-redux';
import {Button} from 'rmwc/Button';
import { Grid, GridCell } from 'rmwc/Grid';
import { Card } from 'rmwc/Card';
import { Typography } from 'rmwc/Typography';
import { TextField } from 'rmwc/TextField';
import { ListDivider } from 'rmwc/List';

import StatusMessage from '../../util/StatusMessage'

class AdminHallTicketUploadHistory extends Component{

  constructor(props){
    super(props);
    this.state={
      uploadHistory: [],
      gobackId: '',
      page: 1,
      total: 0,
      totalPages: '',
      loading: true
    }
  }

  componentDidMount() {
    let certTypeId = this.props.match.params.typeId
    let uploadType = this.props.match.params.uploadType
    return api.getUploadedExcelFileHistory(this.props.user.accessToken, certTypeId, this.state.page, uploadType)
    .then((result) => {
      if(result.status === 'success'){
        this.setState({
          uploadHistory: result.data, totalPages: result.total_count, gobackId:certTypeId, loading: false
        })
      }
    })
  }

  handleGoBack = () => {
    let uploadType = this.props.match.params.uploadType
    if(this.state.gobackId === '3')
      this.props.history.push(`/portal/app/admin/hallticket`)
    else if(this.state.gobackId === '4')
      this.props.history.push(`/portal/app/admin/tq/reports/home`)
    else if(this.state.gobackId === '0' && uploadType === 'userImport')
      this.props.history.push(`/portal/app/admin/user/import/home`)
    else if(this.state.gobackId === '0' && uploadType === 'seminarUserImport')
      this.props.history.push(`/portal/app/admin/seminar/list`)
    else if(this.state.gobackId === '0' && uploadType === 'nationalAvgImport')
      this.props.history.push(`/portal/app/admin/tq/reports/home`)
  }

  onPageTextChange = evt => {
    let page = this.state.page
    page = evt.target.value;
    this.setState({page:page});
  }

  handleFetch = (e)=>{
    let uploadType = this.props.match.params.uploadType
    return api.getUploadedExcelFileHistory(this.props.user.accessToken, this.state.gobackId, this.state.page, uploadType)
    .then((result) => {
      if(result.status === 'success'){
        this.setState({
          uploadHistory: result.data, totalPages: result.total_count
        })
      }
    })
  }

  
  render() {
    let displayComponent ;
    displayComponent =(<tbody>
      {this.state.uploadHistory.map(function (file) {
        let excelFile = (<td>NA</td>)
        let successFile = (<td>NA</td>)
        let errorFile = (<td>NA</td>)
        if(file.upload_file !== undefined){
          excelFile = (<td><a href={file.upload_file} target="_blank">View</a></td>)
        }
        if(file.success_log !== undefined){
          successFile = (<td><a href={file.success_log} target="_blank">View</a></td>)
        }
        if(file.error_log !== undefined){
          errorFile = (<td><a href={file.error_log} target="_blank">View</a></td>)
        }
         return (<tr>
          <td>{file.id}</td>
          <td>{file.name}</td>
          {excelFile}
          {successFile}
          {errorFile}
          <td>{file.progress_status}</td>
          <td>{file.start_time}</td>
          <td>{file.end_time}</td>
          <td>{file.error_msg}</td>
        </tr>);
        })}
    </tbody>)

    let loadingComponent
      if(this.state.loading){
        loadingComponent = (
            <div className="loader-component">
              <div className="loader"></div>
              <h4> Loading... Please wait</h4>
            </div>
          )
      }

    return(
      <Grid>
        <GridCell span="12">
          <Card style={{padding: '25px'}}>
            <Grid>
            <GridCell span="10">
              <Typography use="headline5">Uploaded Excel Files History </Typography>
            </GridCell>
            <GridCell span="2">
              <Button raised onClick={this.handleGoBack}>BACK </Button>
            </GridCell>
            </Grid>
            <br/>
            <ListDivider/>
            <Grid>
              <GridCell span ="2">
                <Typography use="subtitle">Total Pages - {this.state.totalPages}</Typography>
              </GridCell>
              <GridCell span ="10"/>
              {loadingComponent}
              <GridCell span ="2">
                <TextField  className='text_input' label="Page Number" autoComplete="off" name="page" onChange={this.onPageTextChange} value={this.state.page}/>
                <Button raised onClick={this.handleFetch}>Fetch</Button>
              </GridCell>
            </Grid>
            <ListDivider/>
            <br/>
            <GridCell span="12">
              <table>
                <th>Uploaded ID</th>
                <th>File Name</th>
                <th>Uploaded File Links</th>
                <th>Success Log File Links</th>
                <th>Error Log File Links</th>
                <th>Status</th>
                <th>Start Time</th>
                <th>End Time</th>
                <th>Error Message</th>
                {displayComponent}
              </table>
            </GridCell>
          </Card>
        </GridCell>
      </Grid>
      );
  }
}

function mapStateToProps({user, admin}) {
  return {
    user,
    admin
  }
}

function mapDispatchToProps() {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(AdminHallTicketUploadHistory);


// WEBPACK FOOTER //
// ./src/views/admin/AdminHallTicketUploadHistory.jsx